import {
  PresentationType,
  SectionViewBuilderContext,
  SectionWidget,
  ShouldFetchDataResolverContext,
} from "../section-widget";
import { TeamBrandingSectionConfig } from "./team-branding-section-config";
import { TeamBrandingSectionView } from "./team-branding-section-view";
import { v4 as uuidv4 } from "uuid";
import { TeamBrandingSectionData } from "./team-branding-section-data";

type SectionType = "team-branding";

export class TeamBrandingSectionWidget
  implements
    SectionWidget<
      SectionType,
      TeamBrandingSectionConfig,
      TeamBrandingSectionView
    >
{
  type: SectionType = "team-branding" as const;

  supportedPresentationTypes: PresentationType[] = [
    "cma",
    "general-presentation",
  ];

  buildDefaultConfig(): TeamBrandingSectionConfig {
    return {
      type: "team-branding",
      navTitle: "Team Info",
      id: uuidv4(),
      shouldFetchFromUserProfile: true,
      visibility: true,
      name: undefined,
      logo: undefined,
      website: undefined,
      showName: true,
      showLogo: true,
      showWebsite: true,
    };
  }

  buildView({
    sectionConfig: config,
    sectionData: data,
  }: SectionViewBuilderContext<
    TeamBrandingSectionConfig,
    TeamBrandingSectionData
  >): TeamBrandingSectionView {
    if (config.type !== "team-branding")
      throw new Error("Unexpected section type.");

    const { id, type, visibility } = config;

    const {
      name = data?.teamName || null,
      logo = data?.teamLogo || null,
      website = data?.teamWebsite || null,
      showName = true,
      showLogo = true,
      showWebsite = true,
    } = config;

    const view: TeamBrandingSectionView = {
      id,
      type,
      navTitle: config.navTitle || "Team Info",
      name,
      logo,
      website,
      visibility: name || logo ? visibility : false,
      preferences: {
        showName,
        showLogo,
        showWebsite,
      },
    };

    return view;
  }

  shouldInvalidateData(
    _: ShouldFetchDataResolverContext<
      TeamBrandingSectionConfig,
      TeamBrandingSectionData
    >
  ): boolean {
    return false;
  }

  canFetchData({ config }: { config: TeamBrandingSectionConfig }) {
    return Boolean(config.shouldFetchFromUserProfile);
  }
}
